export const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    // Kontrola velikosti
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      reject(new Error('File size must be less than 10MB'));
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        const originalPixels = width * height;

        // Inteligentní změna velikosti - zachová detaily pro menší obrázky
        // Pro velmi velké obrázky (nad 8MP) trochu zmenší pro lepší kompresi
        if (originalPixels > 8000000) { // 8 megapixelů
          const scale = Math.sqrt(8000000 / originalPixels);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        // Optimalizované nastavení pro lepší kvalitu
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        
        // Pro zmenšené obrázky použijeme lepší algoritmus
        if (width !== img.width || height !== img.height) {
          // Kreslíme s antialiasing pro lepší kvalitu při zmenšování
          ctx.drawImage(img, 0, 0, width, height);
        } else {
          // Původní velikost - přímé kopírování
          ctx.drawImage(img, 0, 0);
        }

        // Agresivnější komprese - nižší základní kvality
        let baseQuality;
        const pixelCount = width * height;
        const originalSizeKB = file.size / 1024;
        
        // Základní kvalita podle velikosti původního souboru
        if (originalSizeKB <= 500) { // Malé soubory - zachovat kvalitu
          baseQuality = 0.75;
        } else if (originalSizeKB <= 1500) { // Střední soubory - mírná komprese
          baseQuality = 0.65;
        } else if (originalSizeKB <= 3000) { // Velké soubory - silná komprese
          baseQuality = 0.55;
        } else { // Velmi velké soubory - velmi silná komprese
          baseQuality = 0.45;
        }

        // Další snížení kvality pro velké rozlišení
        if (pixelCount > 4000000) { // Nad 4MP
          baseQuality = Math.max(0.35, baseQuality - 0.1);
        }

        // Testujeme postupně nižší kvality
        const qualityTests = [
          baseQuality,
          baseQuality - 0.1,
          baseQuality - 0.2,
          Math.max(0.25, baseQuality - 0.3) // Minimálně 25%
        ];

        let bestResult = null;
        let bestScore = 0;

        for (const quality of qualityTests) {
          if (quality < 0.25) continue; // Nikdy neklesáme pod 25%
          
          const testBase64 = canvas.toDataURL('image/jpeg', quality);
          const testSize = Math.round((testBase64.length * 3) / 4);
          
          // Preferujeme menší velikosti - agresivnější skórování
          const compressionRatio = 1 - (testSize / file.size);
          const sizeScore = Math.min(1, compressionRatio * 2); // Zvýšený důraz na kompresi
          const qualityScore = quality * 0.5; // Snížený důraz na kvalitu
          const combinedScore = (sizeScore * 0.8) + (qualityScore * 0.2);
          
          if (combinedScore > bestScore) {
            bestScore = combinedScore;
            bestResult = {
              base64: testBase64,
              size: testSize,
              quality: quality
            };
          }
        }

        // Pokud se nepodařilo najít dobrý výsledek, použijeme základní kvalitu
        if (!bestResult) {
          const fallbackBase64 = canvas.toDataURL('image/jpeg', baseQuality);
          bestResult = {
            base64: fallbackBase64,
            size: Math.round((fallbackBase64.length * 3) / 4),
            quality: baseQuality
          };
        }

        console.log(`Image compression optimized:`);
        console.log(`- Original: ${file.size} bytes (${(file.size / 1024).toFixed(1)}KB)`);
        console.log(`- Compressed: ${bestResult.size} bytes (${(bestResult.size / 1024).toFixed(1)}KB)`);
        console.log(`- Quality used: ${(bestResult.quality * 100).toFixed(1)}%`);
        console.log(`- Dimensions: ${width}x${height} (original: ${img.width}x${img.height})`);
        console.log(`- Compression ratio: ${((1 - bestResult.size / file.size) * 100).toFixed(1)}%`);
        
        resolve({
          base64: bestResult.base64,
          width,
          height,
          originalName: file.name,
          size: bestResult.size,
          fileType: 'image/jpeg'
        });
      };
      img.onerror = (error) => reject(error);
    };
    reader.onerror = (error) => reject(error);
  });
};